import { render, staticRenderFns } from "./VehicleHeadlightExcludedProducts.vue?vue&type=template&id=1378c32a"
import script from "./VehicleHeadlightExcludedProducts.vue?vue&type=script&lang=js"
export * from "./VehicleHeadlightExcludedProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductListItem: require('/app/components/ProductListItem.vue').default,VehicleHeadlightExclusionButton: require('/app/components/VehicleHeadlightExclusionButton.vue').default})
